import { useEffect, useState } from "react"
import ApiServices from "../../service/api/ApiServices";
import { Button } from "primereact/button";
import { InputNumber } from "primereact/inputnumber";
import { GSFProductList } from "./GSFProductList";
const saved = localStorage.getItem("user");
const initialValue = JSON.parse(saved);
const apiServices = new ApiServices();
export const GSFSchemeSelect = ({ orderData, preOrderNo, openSchemeDialog }) => {
    const [listScheme, setlistScheme] = useState([]);
    const [selectedScheme, setSelectedScheme] = useState([]);
    const [isProceed, setIsProceed] = useState(false);

    useEffect(() => {
        if (openSchemeDialog) {
            getGSFSchemes()
        }
    }, []);



    const getGSFSchemes = async () => {
        let response = await apiServices.getGSFSchemes({});
        // console.log(response);
        debugger
        response = response?.data.response_obj
        setlistScheme(response || []);
    }

    const handleQuantityChange = (scheme, value) => {
        setSelectedScheme((prev) => {
            if (!value || value === 0) {
                return prev?.filter((item) => item._id !== scheme._id)
            }

            const exit = prev?.find((item) => item._id === scheme._id)
            if (exit) {
                return prev?.map((item) => {
                    if (item._id === scheme._id) {
                        return { ...item, quantity: value }
                    }
                    return item
                })
            } else {
                return [
                    ...prev,
                    {
                        _id: scheme._id,
                        quantity: value,
                        price: scheme.price,
                        zoho_id: scheme.machine_zoho_id,
                        scheme_name: scheme.scheme_name,
                        images: scheme.images[0],
                        // brand: scheme.brand,
                    },
                ];
            }
        })
    }

    return (
        <>
            {!isProceed ? (
                <div className="card">
                    <h5 className="p-m-5">Select Scheme</h5>
                    <div className="p-grid p-nogutter p-justify-start">
                        {listScheme && listScheme.length > 0 ? (
                            listScheme.map((item, index) => (
                                <div key={index} className="p-col-12 p-md-6 p-lg-3 p-p-2">
                                    <div
                                        className="card p-shadow-3 p-p-3"
                                        style={{ borderRadius: "12px", textAlign: "center" }}
                                    >
                                        <img
                                            src={`https://assets.cheriseglobal.com/${item.images[0]}`}
                                            alt={item.scheme_name}
                                            style={{
                                                width: "90%",
                                                height: "300px",
                                                objectFit: "cover",
                                                borderRadius: "8px",
                                            }}
                                        />
                                        <h3 className="p-mt-3">{item.scheme_name}</h3>
                                        <p className="p-text-secondary">{item.description}</p>
                                        <p className="p-mt-3 ">
                                            <strong>Price: ₹{item.price}</strong>
                                        </p>
                                        <div className="p-col-5">
                                            <div className="grid">
                                                <div className="col-12">
                                                    <InputNumber
                                                        value={selectedScheme.find((s) => s._id === item._id)?.quantity || 0}
                                                        inputId="horizontal"
                                                        onChange={(e) => handleQuantityChange(item, e.value)}
                                                        showButtons
                                                        buttonLayout="horizontal"
                                                        min={0}
                                                        max={999}
                                                        inputStyle={{
                                                            textAlign: "center",
                                                            fontSize: "1.5rem",
                                                            fontWeight: "600",
                                                            width: "80px",
                                                            height: "60px",
                                                        }}
                                                        incrementButtonClassName="p-button-success p-button-lg"
                                                        decrementButtonClassName="p-button-danger p-button-lg"
                                                        incrementButtonIcon="pi pi-plus"
                                                        decrementButtonIcon="pi pi-minus"
                                                    />

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <p className="p-col-12 p-text-center">No schemes available.</p>
                        )}
                    </div>

                    <div className="flex justify-content-center mt-12">
                        {selectedScheme.length > 0 ? (
                            <Button
                                className="p-button-lg p-col-12 p-mt-2"
                                icon="pi pi-arrow-right"
                                iconPos="right"
                                label="Proceed"
                                onClick={() => setIsProceed(true)}
                            />
                        ) : (
                            <Button
                                className="p-button-lg p-col-12 p-mt-2"
                                icon="pi pi-arrow-right"
                                iconPos="right"
                                label="Proceed"
                                disabled
                            />
                        )}
                    </div>
                </div>
            ) : (
                <div className="card">
                    <GSFProductList
                        props={orderData}
                        preOrderNo={preOrderNo}
                        selectedSalesMember={orderData.selectedSalesMember}
                        setSelectedSalesMember={orderData.setSelectedSalesMember}
                        selectedScheme={selectedScheme}
                        handleQuantityChange={handleQuantityChange}
                        onBack={() => setIsProceed(false)}
                    />
                </div>
            )}
        </>
    );

}